import { FC, useContext } from 'react';

import { Label, Separator } from '@smartshell/ui-kit';
import classNames from 'classnames';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { TNormalizedItem } from '../../../types';
import { formatMoney, formatPercents, formatSeconds } from '../../../utils';
import s from './CustomTooltip.module.scss';

interface ITooltipProps {
  data: TNormalizedItem;
}
export const CustomTooltip: FC<ITooltipProps> = ({ data }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: {
        currency: { sign: currency },
      },
    },
  } = useContext(SettingsContext);
  if (!data) {
    return null;
  }

  const { total, guests, clients, alias, groupTitle } = data;

  const header = [];

  if (alias) header.push(alias);
  if (groupTitle) header.push(groupTitle);

  return (
    <div className={s.container}>
      <div className={classNames(s.row, s.secondary)}>{header.join(', ')}</div>
      <div className={s.group}>
        <div className={s.row}>
          <span>{t('report.hosts.occupation')}</span>
          {formatSeconds(t, total.time)}
        </div>
        <div className={classNames(s.row, s.secondary)}>
          <span>{t('report.hosts.inPercents')}</span>
          {isNaN(total.percentTime) ? (
            <Label
              iconName="ExclamationIcon"
              color="orange"
              helperText={t('report.hosts.dataContainErrors')}
            />
          ) : (
            formatPercents(total.percentTime)
          )}
        </div>
      </div>
      <Separator />
      <div className={s.row}>
        <span>{t('money.proceeds')}</span>{' '}
        {formatMoney(total.proceeds, currency)}
      </div>
      <Separator />
      <div className={s.group}>
        <div className={s.row}>
          <div className={s.header}>
            <div
              style={{ backgroundColor: '#2C87FD', opacity: 0.3 }}
              className={s.dot}
            />
            {t('guests')}
          </div>
          {formatSeconds(t, guests.time)}
        </div>
        <div className={classNames(s.row, s.secondary)}>
          <div>{t('money.proceeds')}</div>
          {formatMoney(guests.proceeds, currency)}
        </div>
      </div>
      <Separator />
      <div className={s.group}>
        <div className={s.row}>
          <div className={s.header}>
            <div style={{ backgroundColor: '#2C87FD' }} className={s.dot} />
            {t('clients')}
          </div>
          {formatSeconds(t, clients.time)}
        </div>
        <div className={classNames(s.row, s.secondary)}>
          <div>{t('money.proceeds')}</div>
          {formatMoney(clients.proceeds, currency)}
        </div>
      </div>
    </div>
  );
};
